import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetListAPICommand} from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';
import {NameId} from '@drl/core/models';

export class GetSubCategories2Command extends GetListAPICommand<NameId> {
  constructor(apiService: ApiService, adapter: IAdapter<NameId>) {
    super(apiService, adapter, `${environment.cmsApiUrl}/sub-category2`);
  }
}
